var ProVerification = function() {

    var _documentUpload = function(conf) {

        // Modal template
        var modalTemplate = '<div class="modal-dialog modal-lg" role="document">\n' +
            '  <div class="modal-content">\n' +
            '    <div class="modal-header align-items-center">\n' +
            '      <h6 class="modal-title">{heading} <small><span class="kv-zoom-title"></span></small></h6>\n' +
            '      <div class="kv-zoom-actions btn-group">{toggleheader}{fullscreen}{borderless}{close}</div>\n' +
            '    </div>\n' +
            '    <div class="modal-body">\n' +
            '      <div class="floating-buttons btn-group"></div>\n' +
            '      <div class="kv-zoom-body file-zoom-content"></div>\n' + '{prev} {next}\n' +
            '    </div>\n' +
            '  </div>\n' +
            '</div>\n';

        // Buttons inside zoom modal
        var previewZoomButtonClasses = {
            toggleheader: 'btn btn-light btn-icon btn-header-toggle btn-sm',
            fullscreen: 'btn btn-light btn-icon btn-sm',
            borderless: 'btn btn-light btn-icon btn-sm',
            close: 'btn btn-light btn-icon btn-sm'
        };

        // Icons inside zoom modal classes
        var previewZoomButtonIcons = {
            prev: $('html').attr('dir') == 'rtl' ? '<i class="icon-arrow-right32"></i>' : '<i class="icon-arrow-left32"></i>',
            next: $('html').attr('dir') == 'rtl' ? '<i class="icon-arrow-left32"></i>' : '<i class="icon-arrow-right32"></i>',
            toggleheader: '<i class="icon-menu-open"></i>',
            fullscreen: '<i class="icon-screen-full"></i>',
            borderless: '<i class="icon-alignment-unalign"></i>',
            close: '<i class="icon-cross2 font-size-base"></i>'
        };

        // File actions
        var fileActionSettings = {
            zoomClass: '',
            zoomIcon: '<i class="icon-zoomin3"></i>',
            removeClass: '',
            removeErrorClass: 'text-danger',
            removeIcon: '<i class="icon-bin"></i>',
            indicatorNew: '<i class="icon-file-plus text-success"></i>',
            indicatorSuccess: '<i class="icon-checkmark3 file-icon-large text-success"></i>',
            indicatorError: '<i class="icon-cross2 text-danger"></i>',
            indicatorLoading: '<i class="icon-spinner2 spinner text-muted"></i>'
        };

        var $docs = $("#pro-documents");
        $docs.fileinput({
            allowedFileExtensions: ['jpg','png','pdf','doc','docx'],
            uploadUrl: "/verification/upload",
            uploadAsync: true,
            deleteUrl: "/verification/delete",
            showUpload: false, 
            showRemove: false, 
            layoutTemplates: {
                icon: '<i class="icon-file-check"></i>',
                modal: modalTemplate
            },
            initialPreview: conf.initialPreview || [],
            initialPreviewConfig: conf.initialPreviewConfig || [],
            initialPreviewAsData: true,
            overwriteInitial: false,
            minFileCount: 0,
            maxFileCount: 10,
            maxFileSize: 5120,
            browseOnZoneClick: true,
            previewZoomButtonClasses: previewZoomButtonClasses,
            previewZoomButtonIcons: previewZoomButtonIcons,
            fileActionSettings: fileActionSettings
        }).on("filebatchselected", function(event, files) {
            $docs.fileinput("upload");
        });
        
    };

    var _watch = function(){

        $('.specialisms').select2({maximumSelectionLength: 10});
        $('#trading-country').select2();
        $('#validation-verify').on('click',function(){
            $('#verdata').submit();
        });

    };

    var _review = function(conf){
        var $docs = $("#pro-documents");
        $docs.fileinput({
            showUpload: false, 
            showBrowse: false, 
            showRemove: false, 
            showZoom: false,
            initialPreview: conf.initialPreview || [],
            initialPreviewConfig: conf.initialPreviewConfig || [],
            initialPreviewAsData: true,
            // overwriteInitial: false,
        });
        $('.file-caption').addClass('d-none');
        $('.fileinput-remove').addClass('d-none');
        $('.file-actions').addClass('d-none');

    }

    return {

        init: function(c) {
            _documentUpload(c);
        },
        watch: function() {
            _watch();
        },
        review: function(c) {
            _review(c);
        }

    }

}();


